import { State } from '../menu-list.slice';

export function hasSelectedAll(state: State): boolean {
  return state.selected.length === state.available.length;
}

export default {
  hasSelectedAll,
};
